/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import _ from 'lodash';
import { loadVideos } from '@/video/api';

const state = {
  videos: [],
  lastPage: 1,
  loadVideosListState: {
    status: 'idle',
    error: null,
  },
};

const defaultState = {
  videos: [],
  lastPage: 1,
  loadVideosListState: {
    status: 'idle',
    error: null,
  },
};

const getters = {
};

const mutations = {
  setVideosListState(state, response) {
    // const videos = response.data;
    // const newVideos = _.mapKeys(videos, (video) => video.id);
    state.videos = response.data;
    state.lastPage = response.lastPage;
  },
  setLoadVideosListState(state, message) {
    switch (message.type) {
      case 'loading':
        state.loadVideosListState.status = 'loading';
        state.loadVideosListState.error = null;
        break;
      case 'success':
        state.loadVideosListState.status = 'success';
        break;
      case 'error':
        state.loadVideosListState.status = 'error';
        state.loadVideosListState.error = message.payload;
        break;
      default:
        state.loadVideosListState.status = 'idle';
        state.loadVideosListState.error = null;
    }
  },
  destroyVideosList(state) {
    Object.assign(state, _.cloneDeep(defaultState));
  },
};

const actions = {
  async loadVideosList({ dispatch, commit }, filter) {
    try {
      commit('destroyVideosList');
      commit('setLoadVideosListState', { type: 'loading' });
      const response = await loadVideos(filter);
      await dispatch('setVideosListState', response.data);
      commit('setLoadVideosListState', { type: 'success' });
    } catch (error) {
      commit('setLoadVideosListState', {
        type: 'error',
        payload: error.response,
      });
    }
  },
  setVideosListState({ commit }, response) {
    commit('setVideosListState', response);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
